export default __webpack_public_path__ + "static/media/Kuthcheman Pernach.5ae8020b.jpg";